module.exports = __webpack_public_path__ + "img/4.3fd4e002.svg";